import { useFormContext } from "react-hook-form";
import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import { useEffect } from "react";
import {
  durationOptions,
  durationDictionary,
  durationOptionSchema,
  type IDurationOption,
} from "./activityDurationModels";
import {
  CustomActivityDuration,
  type ICustomActivityDurationFields,
} from "./CustomActivityDuration";
import { useLingui } from "@lingui/react/macro";

export type IActivityDurationFields = ICustomActivityDurationFields & {
  durationOption: IDurationOption;
};

export const ActivityDuration = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
    watch,
    unregister,
  } = useFormContext<IActivityDurationFields>();

  const selectedDuration = watch("durationOption");
  const isCustomDuration =
    selectedDuration === durationOptionSchema.enum.custom;

  // Unregister the custom duration fields if not using custom
  useEffect(() => {
    if (!isCustomDuration) {
      unregister("customDuration");
      unregister("customDurationUnit");
    }
  }, [isCustomDuration, unregister]);

  return (
    <>
      <RadioButtons
        legend={t`Tidsåtgång`}
        errorMessage={errors.durationOption?.message}
        orientation="horizontal"
      >
        {durationOptions.map((option) => (
          <RadioButton
            key={option}
            label={{ text: t(durationDictionary[option].displayText) }}
            visualStyle="framed"
            value={option}
            {...register("durationOption", {
              required: {
                value: true,
                message: t`Välj tidsåtgång`,
              },
            })}
          />
        ))}
      </RadioButtons>
      {isCustomDuration ? <CustomActivityDuration /> : null}
    </>
  );
};
